export default {
  personalWorkspace: 'Personal workspace',
  switchToCompany: 'Switch to company',
  switchToPersonal: 'Switch to personal',
  switchCompany: 'Switch company',
  profile: 'Profile',
  settings: 'Settings',
  logout: 'Log out',
  logoutConfirmTitle: 'Confirm',
  logoutConfirmMessage: 'Are you sure you want to log out?',
  logoutConfirmOk: 'Log out',
  logoutConfirmCancel: 'Cancel',
  logoutSuccess: 'Logged out',
  language: 'Language',
  quickMenu: {
    settings: 'Settings',
    upload: 'Upload',
    retouch: 'Retouch',
    qc: 'QC',
    audit: 'Review',
    share: 'Share',
    pack: 'Pack'
  }
}
